import { Component, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { InmediatePendingOrdersService, PendingOrdersServiceData } from "../../services/ordersKpi/pendingOrders.service";
import { InmediatePendingOrdersDetailService, PendingOrdersDetailServiceData } from "../../services/ordersKpi/pendingOrdersDetail.service";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { PendingOrdersData } from "./pendingOrdersData";

@Component({
    selector: 'inmediate-pending-orders-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class InmediatePendingOrdersKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<InmediatePendingOrdersService, PendingOrdersServiceData, PendingOrdersData, InmediatePendingOrdersDetailService, PendingOrdersDetailServiceData, PendingOrdersDetailServiceData>  
    implements OnDestroy {
    public getClassName() { return "InmediatePendingOrdersKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: InmediatePendingOrdersService, detailService: InmediatePendingOrdersDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: PendingOrdersServiceData): PendingOrdersData {
        return new PendingOrdersData(
            data.consultantBucketPermanent + data.consultantBucketTEA + data.consultantNoBucketPermanent + data.consultantNoBucketTEA,
            data.consultantBucketPermanent + data.consultantBucketTEA,
            data.officeBucketPermanent + data.officeBucketTEA + data.officeNoBucketPermanent + data.officeNoBucketTEA,
            data.officeBucketPermanent + data.officeBucketTEA
        );
    }

    protected getDefaultSummaryData(): PendingOrdersData {
        let data = new PendingOrdersData(0, 0, 0, 0);
        return data;
    }

    protected extractUpdateTime(data: PendingOrdersServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: PendingOrdersDetailServiceData): PendingOrdersDetailServiceData {
        return data;
    }

    protected performDetailAction(): void {
        if (this.detailData) window.open(this.detailData.link, "_blank");
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}